import { render, staticRenderFns } from "./HolidaysModal.vue?vue&type=template&id=c963e4cc"
import script from "./HolidaysModal.vue?vue&type=script&lang=js"
export * from "./HolidaysModal.vue?vue&type=script&lang=js"
import style0 from "./HolidaysModal.vue?vue&type=style&index=0&id=c963e4cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports